import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MapPin, X } from "lucide-react";

/**
 * Component to display a list of waypoints with the ability to remove them
 * @param {Object} props - Component props
 * @param {Array} props.waypoints - Array of waypoint objects
 * @param {Function} props.removeWaypoint - Function to remove a waypoint by index
 * @returns {JSX.Element} - Rendered component
 */
const WaypointsList = ({ waypoints, removeWaypoint }) => {
  if (!waypoints || waypoints.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Waypoints</CardTitle>
        <CardDescription>
          Click on a waypoint marker to remove it
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {waypoints.map((waypoint, index) => (
            <div
              key={index}
              className="flex items-center justify-between bg-gray-50 dark:bg-gray-700 p-2 rounded"
            >
              <div className="flex items-center">
                <MapPin className="h-4 w-4 mr-2 text-blue-500" />
                <span>
                  Waypoint {index + 1}: {waypoint.location.lat.toFixed(4)},{" "}
                  {waypoint.location.lng.toFixed(4)}
                </span>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => removeWaypoint(index)}
                className="p-1 h-auto"
                aria-label={`Remove waypoint ${index + 1}`}
              >
                <X className="h-4 w-4 text-gray-500" />
              </Button>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default WaypointsList;
